import axios from 'axios';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { RenderInputWithDiv } from '../../../component/formInput';

class MobileVersionEditModal extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
        
      }
  }

  componentDidMount() {

  }
  
  submit = (values) => {
    const { onHide, mobileVersionObj } = this.props;
    return axios({
      method: 'post',
      url: window.api_url+ '/admin/api/mobile/version/update',
      data: {
        version: values.version,
        build: values.build,
        id: mobileVersionObj.id
      },
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        onHide();
      }else {
        throw new SubmissionError(response.data.error);
      }
    })
  }
  
  render() {
    const { title, handleSubmit, submitting, onHide } = this.props;
    const modalConfig = { backdrop: 'static', show: this.props.show, bssize: "medium", onHide: this.props.onHide, submitting: this.props.submitting };

    const newModal = <div style={{ width: '30%' }}>
    <Modal
      {...modalConfig}
      aria-labelledby="contained-modal-title-lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-sm"><center>{title}</center> </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="form-horizontal" role="form" onSubmit={handleSubmit(this.submit)}>
          <Field name="type" label="Type" disabled component={RenderInputWithDiv}></Field>
          <Field name="version" label="Version" component={RenderInputWithDiv}></Field>
          <Field name="build" label="Build" component={RenderInputWithDiv}></Field>
          <div className="text-right">
            <a onClick={()=>onHide()} className={"btn"}>
              Đóng
            </a>
            <button type="submit" className={"btn bg-blue btn-primary " + (submitting ? "disabled" : "")}>
              Lưu <i className="icon-arrow-right14 position-right"></i>
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
    </div>
    return newModal;
  }
};
const mapState = (state, props) => ({
  initialValues: {
    version: props.mobileVersionObj && props.mobileVersionObj.version,
    build: props.mobileVersionObj && props.mobileVersionObj.build,
    type: props.mobileVersionObj && props.mobileVersionObj.type,
  },
  userProfile: state.userProfile.data
});

const mapDispatch = dispatch => ({
  
});

export default (connect(mapState, mapDispatch)(
  reduxForm({
    form: 'MobileVersionEditModal',
    destroyOnUnmount: true,
    enableReinitialize: true
  })(withRouter(MobileVersionEditModal))));
